import React from "react"
import { Container } from "./FreeTrialBadge.styled"
import { ReactComponent as BellIcon } from "images/icons/bell.svg"

type Props = {
  untilDate: string
}

const FreeTrialBadge = ({ untilDate }: Props) => {
  return (
    <Container>
      <BellIcon />
      <div>
        <b>Free trial</b>
        <span>Until: {untilDate}</span>
      </div>
    </Container>
  )
}

export default FreeTrialBadge
